import { OverrideExperiment } from '@contexts/experiment/types';
import { WindowObj } from '@utils/windowObj';

export function getOverrideExperiments(): OverrideExperiment {
    const parentSearchParams = new URLSearchParams(WindowObj.parent.location.search);
    const expListParam = parentSearchParams.get('explist');
    const expuser = parentSearchParams.get('expuser') || undefined;
    const explist = expListParam
        ? expListParam
              .split(',')
              .filter(exp => !!exp)
              .reduce((previousValue, currentValue) => {
                  const [expKey, expValue] = currentValue.split('=');
                  return {
                      ...previousValue,
                      [expKey]: expValue,
                  };
              }, {})
        : undefined;

    return { explist, expuser };
}
